import React from "react";
import "./footer.css";
import { FaFacebookSquare, FaInstagramSquare } from "react-icons/fa";
import { BsLinkedin } from "react-icons/bs";
import { AiFillTwitterSquare } from "react-icons/ai";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { AiOutlineTwitter, AiOutlineInstagram } from "react-icons/ai";
import Zoom from "react-reveal/Zoom";
const Footer = () => {
  return (
    <div className="container-fluid footer">
      <div className="container">
        <Zoom>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
              <div className="footer-about-section">
                <h6
                  style={{
                    color: "white",
                    marginTop: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  About
                </h6>
                <p
                  style={{
                    textAlign: "justify",
                  }}
                >
                  Value Seeds Limited is an indigenous Nigerian seed Company
                  incorporated in September 14, 2009, focused on the production
                  and distribution of high-quality field crops and vegetable
                  seeds. We are a leading agricultural value chain solution
                  provider, specializing in seed research, multiplication,
                  processing and distribution.
                </p>

                <div className="footer-social-icons">
                  <p>
                    <a
                      target="blank"
                      href="https://web.facebook.com/valueseedsng"
                    >
                      <FaFacebookF size={25} />
                    </a>
                  </p>

                  <p>
                    <a
                      target="blannk"
                      href="https://www.linkedin.com/in/value-seeds-370239108/"
                    >
                      <FaLinkedinIn size={25} />
                    </a>
                  </p>
                  <p>
                    <a target="blank" href="https://x.com/ValueSeeds">
                      <AiOutlineTwitter size={25} />
                    </a>
                  </p>
                  <p>
                    <a
                      target="blank"
                      href="https://www.instagram.com/valueseedslimited?igsh=MXU5a2ExbXpldnprbQ=="
                    >
                      <AiOutlineInstagram size={25} />
                    </a>
                  </p>
                </div>
                {/* <span className="footer-social-icons">
                <p>
                  <FaFacebookSquare size={30} />
                </p>
                <p>
                  <AiFillTwitterSquare size={30} />
                </p>
                <p>
                  <FaInstagramSquare size={30} />
                </p>
                <p>
                  <BsLinkedin size={30} />
                </p>
              </span> */}
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
              <div className="footer-service">
                <h6 style={{ color: "white", marginTop: "20px" }}>
                  Our Core Values
                </h6>
                <div className="footer-item">
                  <li>Integrity</li>
                  <li>Accountability</li>

                  <li>Innovation</li>

                  <li>Professionalism</li>

                  <li>Resourcefulness</li>

                  <li>Value Addition</li>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
              <div className="footer-service">
                <h6
                  style={{
                    color: "white",
                    marginTop: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Our Location
                </h6>
                <p
                  style={{
                    textAlign: "justify",
                    color: "white",
                  }}
                >
                  <b>HEAD OFFICE: </b>Value Village, Kilometer 7, Zaria-Kano
                  Expressway, Tashan Ya'u, Kudan Junction, Bagaddi, Zaria,
                  Kaduna State
                </p>

                <div className="footer-item">
                  <li>08089828831, 08033175351</li>
                  <li>valueseedsng@yahoo.com, info@valueseedsltd.com</li>
                </div>
              </div>
              <div>
                <p
                  style={{
                    textAlign: "right",
                    color: "yellow",
                  }}
                >
                  &copy; Bliss-Mega InfoTech, 2025
                </p>
              </div>
            </div>
          </div>
        </Zoom>
      </div>
    </div>
  );
};

export default Footer;
